export default "__VITE_ASSET__HVrFmzpG__"